import * as React from "react";
import { Button, ThemeFactory } from "@skbkontur/react-ui";
import { KonturColors as Colors } from "@skbkontur/colors";
// todo: нужно сделать общую кнопку(в реакт-юай или тут)
// кнопка так же есть в keweb.front/src/newsFeedPanel/redesignOnboardingBanner/RedesignOnboardingBanner.tsx
// задачка https://yt.skbkontur.ru/issue/KE-21680
var blueBackgroundTheme = ThemeFactory.create({
    btnPrimaryBg: "transparent",
    btnPrimaryHoverBg: "rgba(255, 255, 255, 0.06)",
    btnPrimaryActiveBg: "rgba(255, 255, 255, 0.1)",
    btnPrimaryBorderColor: Colors.grayscaleBackground,
    btnPrimaryHoverBorderColor: Colors.grayscaleBackground,
    btnPrimaryActiveBorderColor: Colors.grayscaleBackground,
});
export function TourButton(props) {
    return (React.createElement("div", { style: { display: "inline-block" } },
        React.createElement(Button, { style: props.style, theme: props.blueBackground ? blueBackgroundTheme : undefined, use: props.use || "default", onClick: props.onClick, "data-tid": "TourButton " +
                "".concat((props.arrow === "left" && "TourButtonLeftArrow") || "") +
                "".concat((props.arrow === "right" && "TourButtonRightArrow") || "") },
            React.createElement("div", { style: { position: "relative" } },
                props.arrow === "left" && "←",
                " ",
                props.children,
                " ",
                props.arrow === "right" && "→"))));
}
